import React from "react";
import { Product } from "../../interfaces";
import useRequest from "@Hooks/useRequest";
import ProductListItem from "./ProductListItem";

import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FontWeight } from "theme/fonts";

const useStyles = makeStyles(theme => ({
  productItemHeader: {
    minHeight: 48,
    alignContent: "center",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(0, 2),
  },
  productListItem: {
    padding: theme.spacing(0, 0, 1),
  },
  productList: {
    padding: theme.spacing(0),
    marginTop: theme.spacing(2),
    maxWidth: 600,
  },
  itemPrice: {
    fontWeight: FontWeight.Bold,
  },
  itemButton: {
    width: "100%",
    maxWidth: 450,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up("md")]: {
      width: "unset",
      marginBottom: 0,
    },
  },
  itemTitle: {
    textAlign: "center",
    fontSize: theme.typography.fontSize + 10,
    [theme.breakpoints.up("md")]: {
      ...theme.typography.h6,
      textAlign: "left",
    },
  },
  itemRequirements: {},
  itemText: {
    padding: theme.spacing(1),
  },
}));

export interface ProductListProps {
  products?: Product[];
}

const ProductList = (_props: ProductListProps) => {
  const { data, error } = useRequest<Product[]>(
    { url: "/api/products" },
    // {
    //   fallbackData: props.products,
    // },
  );

  const classes = useStyles();

  return (
    <Grid container spacing={2} justifyContent="center">
      {data && data.length > 0 ? (
        data.map((entry, key) => {
          return (
            <Grid item xs={12} md={6} key={key} className={classes.productList}>
              <ProductListItem item={entry} key={key} />
            </Grid>
          );
        })
      ) : error ? (
        <Typography>There was an issue fetching products...</Typography>
      ) : (
        <div>loading...</div>
      )}
    </Grid>
  );
};

export default ProductList;
